import React, { useMemo } from 'react'
import { Button } from '@did/das-balance-components'
import { FIAT_DECIMAL_PLACES } from '@did/constants'
import { useDasBalanceContext } from '@did/das-app-context'
import { DidPointBalanceType } from '@did/das-balance-types'
import { thousandSplit, cn } from '@did/tools'

export const DidPointBalance: DidPointBalanceType = ({
  className,
  balance
}) => {
  const { tt, router, alert } = useDasBalanceContext()

  const balanceStr = useMemo(() => {
    return thousandSplit(balance, FIAT_DECIMAL_PLACES)
  }, [balance])

  const onTopUp = () => {
    router.push('/credits/topup')
  }

  const onWithdraw = () => {
    alert({
      title: tt('Tips'),
      message: tt('Coming soon')
    })
  }

  return (
    <div
      className={cn(
        'shadow-sm border border-gray-200 bg-white sm:p-6 p-4 rounded-3xl',
        className
      )}
    >
      <div className="flex flex-col items-center mt-8">
        <div className="text-4xl text-primary font-['Barlow-Medium']">
          {balanceStr}{' '}
          <span className="text-gray-350">
            {balance && Number(balance) == 1 ? 'Credit' : 'Credits'}
          </span>
        </div>
        <div className="mt-1 text-gray-500 mb-8">${balanceStr}</div>
      </div>
      <div className="flex items-center">
        <Button className="mr-4" middle black block onClick={onTopUp}>
          {tt('Top Up')}
        </Button>
        <Button className="!cursor-no-drop" middle block onClick={onWithdraw}>
          {tt('Withdraw')}
        </Button>
      </div>
    </div>
  )
}

export default DidPointBalance
